import { Injectable } from '@angular/core';
import { eLinkButtonTarget } from '../common/components/general/link-button/link-button.model';
import { Observable, of, Subject, tap } from 'rxjs';
import { BaseService } from '../common/services/base.service';
import { CacheService } from '../common/services/cache.service';
import { SelectOption } from '../common/components/general/select/select.model';
import { CACHE_KEYS } from '../common/constants/cache-keys';
import { AuthGenerateResendReq, AuthResponse, AuthVerifyReq, Dealer, GetAllDealersResponse, GetAllRolesResponse, LanguageResponse, LoginLinkout, LoginRequest, LoginResponse, LoginResults, LoginSelections, LogoutResponse, Role, UserLookupResponse } from './login.viewmodel';
import { PageService } from '../common/services/page/page.service';
import { ContentModel } from '../common/models/content.model';
import { SettingsService } from '../common/services/settings.service';
import { Language } from '../common/components/language-switcher/language-switcher.model';
import { UserAuthDetails, UserContext } from '../common/models/user-details.model';
import { UtilsService } from '../common/services/utils.service';
import { environment } from '../../environments/environment';
import { AuthService } from '../common/services/auth/auth.service';
import { LPMI_ROUTES } from '../common/constants/routes';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  loginLinkouts: LoginLinkout[] = [
    { type: eLinkButtonTarget.NEW_WINDOW, text: 'Helpdesk', hrefLink: '/popup' },
    { type: eLinkButtonTarget.NEW_WINDOW, text: 'Privacy Notice', hrefLink: '/popup' },
    { type: eLinkButtonTarget.NEW_WINDOW, text: 'Cookie Policy', hrefLink: '/popup' },
    { type: eLinkButtonTarget.NEW_WINDOW, text: 'Site Status', hrefLink: '/popup' },
    { type: eLinkButtonTarget.NEW_WINDOW, text: 'Legal Notice', hrefLink: '/popup' },
  ];

  userLoginDetails: LoginResults;
  private timer: number = 1 * 60;
  private timerInterval: any;
  private isRunning: boolean = false;
  // url: string;
  public timerSubject: Subject<string> = new Subject<string>();

  constructor(protected baseService: BaseService, protected cacheService: CacheService, private router: Router, private pageService: PageService, private authService: AuthService, private utilsService: UtilsService,

  ) { }

  getLpmiUserRoles(): Observable<LoginResponse> {
    let url = `/v1/lpmi/user/getLpmiUserRoles`;

    return this.baseService.get<LoginResponse>(url).pipe(
      tap((response: LoginResponse) => {
        let logInResponse: LoginResponse = response;
        logInResponse.results.hasMultiRole = this.hasMultiRoles(logInResponse?.results?.dealerLists);
        logInResponse.results.hasMultiBusinessOp = this.hasMultiBusinessOps(logInResponse?.results?.dealerLists);
        this.cacheService.addToCache(CACHE_KEYS.LOGIN.LOGIN_DATA, logInResponse?.results);
        return logInResponse;
      })
    );
  }

  logout(): Observable<LogoutResponse> {
    let url: string = `/v1/user/logout`;
    let requestBody = {
      userDetails: this.pageService.getUserDetails(),
    }
    return this.baseService.post<LogoutResponse>(url, requestBody).pipe(
      tap((response: LogoutResponse) => {
      })
    );
  }

  getLanguagesByMarketCode(market?: string, region?: string): Observable<LanguageResponse> {
    let url: string = `/v1/lpmi/portal/getLpmiLanguagesByMarketCode`;
    let requestBody = {
      market: market,
      region: region,
      userDetails: this.pageService.getUserDetails()
    }
    // return this.mockLangByDealerCode().pipe(
    return this.baseService.post<any>(url, requestBody, 'API').pipe(
      tap((response: LanguageResponse) => {
        response;
      })
    );
  }

  pingfedLogout() {
    const url = environment.PINGFED_LOGOUT;
    return this.baseService.get<any>(url, null, '', true);
  }

  private hasMultiBusinessOps(dealers: Dealer[]): boolean {
    let businessUnitOptions = dealers?.flatMap((dlr) => {
      return dlr?.roleList?.map((r: Role) => new SelectOption(r.businessOp, r.businessOpLabel));
    });
    businessUnitOptions = SelectOption?.getDistinct(businessUnitOptions);
    return businessUnitOptions?.length > 1;
  }

  private hasMultiRoles(dealers: Dealer[]): boolean {
    let roleOptions = dealers?.flatMap((dlr) => {
      return dlr?.roleList?.map((r: Role) => new SelectOption(r.roleName, r.roleLabel));
    });
    roleOptions = SelectOption?.getDistinct(roleOptions);
    return roleOptions?.length > 1;
  }


  getLoginLinkouts() {
    return this.loginLinkouts;
  }

  idpLogout() {
    this.authService.logout();
  }

  getContent(componentType: string, routeData: any): ContentModel[] {
    return this.pageService.getPageContent(componentType, routeData);
  }

  public getAuthUserDetails(): UserAuthDetails {
    this.userLoginDetails = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA) as LoginResults;
    let userSelections = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_SELECTIONS) as LoginSelections;

    let language: Language = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LANGUAGE) as Language;
    // let userPrefDetails = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.USER_PREF);
    let selectedDealerData: string[] = userSelections?.selectedDealer?.key?.split('-');

    let userContext: UserContext = {
      businessUnit: userSelections?.selectedBusinessLabel?.key,
      roleName: userSelections?.selectedRole?.key ? userSelections?.selectedRole?.key : '-',
      dealerCode: selectedDealerData ? selectedDealerData[0]?.trim() : '',
      dealerName: selectedDealerData ? selectedDealerData[1]?.trim() : '',
      languageCode: language?.languageCode,
    };

    let userDetails: UserAuthDetails = {
      userName: this.userLoginDetails?.userName ?? '',
      userId: userSelections?.userId,
      email: this.userLoginDetails?.userEmail,
      userType: this.userLoginDetails?.userType,
      mobileNumber: this.userLoginDetails?.telePhoneNumber,
      market: this.userLoginDetails?.market,
      isAdmin: this.userLoginDetails?.isAdmin,
      currentContext: userContext,
      firstName: this.userLoginDetails?.userFirstName,
      lastName: this.userLoginDetails?.userLastName,
      sessionId: this.utilsService.getUUID(),
    };
    return userDetails;
  }
}
